export default __webpack_public_path__ + "img/26545497944dd683947cd37ec806b965.png";